import { fg } from '@atlaskit/platform-feature-flags/fg';

export const isCreditsDegradationUiEnabled = (): boolean => {
	try {
		return fg('rovo_credits_degradation_ui');
	} catch {
		// Feature-gate lookup should not be able to crash Rovo surfaces. When
		// the gate cannot be evaluated, treat it as off.
		return false;
	}
};
